export const environment = {
    production: true,
    serviceApi: 'https://www.telkomsel.com/api/',
    drupalApi: 'https://www.telkomsel.com/',
    gtmKey: 'GTM-53KRC3',
    i18nPrefix: 'shops/promo/'
};
